// extracted by mini-css-extract-plugin
module.exports = {"dh-psy-byline":"dh-psy-byline","dh-psy-byline__trigger":"dh-psy-byline__trigger","dh-psy-byline__body":"dh-psy-byline__body","dh-psy-byline--intro":"dh-psy-byline--intro"};